import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  ListItemIcon,
  Divider,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import Person from '@mui/icons-material/Person';
import { useMsal } from "@azure/msal-react";

const ProfileDropdown = () => {
  const { instance } = useMsal();
  const [menuEl, setMenuEl] = useState(null);
  const isOpen = Boolean(menuEl);

  const handleOpen = (event) => {
    setMenuEl(event.currentTarget);
  };

  const handleClose = () => {
    setMenuEl(null);
  };

  const handleViewProfile = () => {
    console.log('Navigate to Profile');
    handleClose();
  };

  const handleSettings = () => {
    console.log('Navigate to Settings');
    handleClose();
  };

  const handleLogout = () => {
    localStorage.clear();
    instance.logoutRedirect();
  };

  return (
    <>
      <Tooltip title="My Profile">
        <IconButton onClick={handleOpen} size="small" sx={{ color: 'inherit' }}>
          <AccountCircleIcon fontSize="large" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={menuEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          elevation: 4,
          sx: {
            borderRadius: 2,
            mt: 1,
            minWidth: 180,
            paddingY: 1,
            backgroundColor: '#000', // Black background
            color: '#fff', // White text
            '& .MuiMenuItem-root': {
              fontSize: 14,
              paddingY: 1,
              color: '#fff',
              '&:hover': {
                backgroundColor: '#333',
              },
            },
            '& .MuiListItemIcon-root': {
              color: '#fff',
              minWidth: 36,
            },
            '& .MuiDivider-root': {
              borderColor: '#555',
            },
          },
        }}
      >
        {/* <MenuItem onClick={handleViewProfile}>
          <ListItemIcon>
            <Person fontSize="small" />
          </ListItemIcon>
          View Profile
        </MenuItem>
        <MenuItem onClick={handleSettings}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <Divider /> */}
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileDropdown;

